// Module
var code = "<svg width=\"8\" height=\"4\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.375 3.5a1 1 0 0 0 1.25 0l2.149-1.72c.738-.59.32-1.78-.625-1.78H1.851C.906 0 .488 1.19 1.226 1.78l2.15 1.72Z\"/> </svg>";
// Exports
module.exports = code;